import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";
import {
  changeTextFilter
} from "../../../store/actions/documentsWithSearch/index";
import { VaporButton, VaporInput } from "../../vapor";

const Search = props => {
  const {
    handleGetDocumentsWithSearch,
    updateState
  } = props;
  const textValue = useSelector(state => state.documentsWithSearch.txtSearch || "");
  const currentLink = useSelector(state => state.documentsWithSearch.currentLink);
  const dispatch = useDispatch();

  const searchLabel = useIntl().formatMessage({ id: "documents.searchLabel" });
  const searchPlaceholder = useIntl().formatMessage({
    id: "documents.searchPlaceholder"
  });

  const searchText = () => {
    if (window.aptrinsic) {
      window.aptrinsic("track", "digital-box:DOCUMENT_SEARCH");
    }
    let removeProps = [];
    let additionalProps = {
      sortOnField: "_score",
      sortOrder: "desc",
      page: 0
    };
    if (textValue === "") {
      removeProps.push("prefix");
      removeProps.push("sortOnField");
      removeProps.push("sortOrder");
      removeProps.push("page");
      additionalProps = {};
    }
    handleGetDocumentsWithSearch({
      link: currentLink,
      search: textValue,
      removeProps,
      additionalProps
    });
    updateState();
  };

  return (
    <div style={{ display: "flex", alignItems: "flex-end", flex: "1", marginRight: "40px" }}>
      <div style={{ width: "100%" }}>
        <div style={{ flex: "1 0 auto", width: "100%" }}>
          <VaporInput
            label={
              searchLabel + "?"
            }
            id="searchDocuments"
            value={textValue}
            onChange={e => dispatch(changeTextFilter(e.target?.value))}
            onKeyPress={e => {
              if (e.charCode === 13) {
                const btnToClick = document.getElementById("searchButton");
                if (btnToClick) btnToClick.click();
                updateState();
              }
            }}
            placeholder={searchPlaceholder}
          />
        </div>
      </div>
      <div>
        <VaporButton id="searchButton"
          style={{ width: "40px" }}
          onClick={searchText}
        >
          <FontAwesomeIcon
            icon={["far", "search"]}
            style={{ fontSize: "18px" }}
          />
        </VaporButton>
      </div>
    </div>
  );
};

export default Search;
